"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Note: this is all temporary - how listings are handled on the view side would actually depend on the
 * listing type.
 */
var isExternalUrl = function (launchUrl) {
    return launchUrl && launchUrl.indexOf("://") >= 0;
};
exports.isExternalUrl = isExternalUrl;
var isExternalListing = function (listing) {
    return listing ? isExternalUrl(listing.launch_url) : false;
};
exports.isExternalListing = isExternalListing;
var isApplicationUrl = function (launchUrl) {
    return launchUrl && launchUrl.endsWith(".js");
};
exports.isApplicationUrl = isApplicationUrl;
var isApplicationListing = function (listing) {
    return listing ? isApplicationUrl(listing.launch_url) : false;
};
exports.isApplicationListing = isApplicationListing;
var isOwner = function (listing, userProfile) {
    return listing && listing.owners && listing.owners.some(function (o) { return o.id === userProfile.id; });
};
exports.isOwner = isOwner;
